import React from 'react';
import { Link } from 'react-router-dom';

function Landing() {
    return (
        <div className="page landing-page">
            <section className="landing-hero">
                <div>
                    <span className="hero-eyebrow">Less scrolling, more cooking</span>
                    <h1 className="hero-title">Recipes without the runaround</h1>
                    <p className="hero-subtitle">
                        RecipeCore trims the story time and gives you clean ingredients, instructions, and tags you can trust.
                    </p>
                    <div className="hero-actions">
                        <Link className="btn btn-primary" to="/login">Launch workspace</Link>
                        <Link className="btn btn-secondary" to="/register">Create free account</Link>
                    </div>
                </div>
                <div className="panel panel-accent">
                    <h3>How it works</h3>
                    <ul className="hero-list">
                        <li>Paste any recipe URL or drop the raw text into RecipeCore.</li>
                        <li>We extract structured ingredients, instructions, and even tag suggestions.</li>
                        <li>Save recipes to your personal collection and keep them organized.</li>
                    </ul>
                </div>
            </section>

            <section className="page-section">
                <div className="page-header">
                    <span className="page-eyebrow">Why RecipeCore</span>
                    <h2>Built for utility-first cooks</h2>
                    <p className="page-subtitle">
                        Whether you are planning a dinner party or just weeknight meals, RecipeCore gives you the exact steps without distractions.
                    </p>
                </div>
                <div className="feature-grid">
                    <article className="feature-card">
                        <h3 className="feature-card-title">Browser-to-bowl fast</h3>
                        <p>Drop in a link and instantly get a tidy, scannable recipe ready for your grocery list.</p>
                    </article>
                    <article className="feature-card">
                        <h3 className="feature-card-title">Save what matters</h3>
                        <p>Organize recipes with custom tags, search, and revisit them any time from your profile.</p>
                    </article>
                    <article className="feature-card">
                        <h3 className="feature-card-title">No ads if you do not want them</h3>
                        <p>Support RecipeCore once to remove ads forever and keep your focus on the food.</p>
                    </article>
                </div>
            </section>
        </div>
    );
}

export default Landing;
